import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=0e4789c8"
import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports